module.exports = __webpack_public_path__ + "static/media/icon-circle-cyan.3b1fbe27.svg";